import { render, staticRenderFns } from "./ChangingExpiredPassword.vue?vue&type=template&id=4a9ee6b7"
import script from "./ChangingExpiredPassword.vue?vue&type=script&lang=js"
export * from "./ChangingExpiredPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports